import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProfileContainer({ children }: { children: React.ReactNode }) {
  return (
    <div
      className={cn(
        'custom-container',
        'flex flex-col items-center justify-center gap-8 sm:gap-12 lg:gap-16',
      )}
    >
      {children}
    </div>
  );
}
